
import { Grid2X2, List } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './button';

interface ViewToggleProps {
  view: 'grid' | 'list';
  onChange: (view: 'grid' | 'list') => void;
  className?: string;
}

const ViewToggle = ({ view, onChange, className }: ViewToggleProps) => {
  return (
    <div className={cn("flex items-center space-x-1 bg-gray-100 rounded-md p-1", className)}>
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "h-8 w-8 p-0",
          view === "grid" ? "bg-white shadow-sm" : "bg-transparent hover:bg-gray-200"
        )}
        onClick={() => onChange("grid")}
      >
        <Grid2X2 size={16} className={view === "grid" ? "text-bytesplash-blue" : "text-gray-500"} />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "h-8 w-8 p-0",
          view === "list" ? "bg-white shadow-sm" : "bg-transparent hover:bg-gray-200"
        )}
        onClick={() => onChange("list")}
      >
        <List size={16} className={view === "list" ? "text-bytesplash-blue" : "text-gray-500"} />
      </Button>
    </div>
  );
};

export default ViewToggle;
